import { NgModule, NgZone, SkipSelf, Optional } from '@angular/core';
import { Responsive } from './media.service';
import { PLATFORM_ID } from '@angular/core';
import { MediaDirective } from './media/media.directive';
export function responsiveProviderFactory(parent, ngZone, platformId) {
    return parent || new Responsive(ngZone, platformId);
}
export var responsiveProvider = {
    provide: Responsive,
    deps: [[new Optional(), new SkipSelf(), Responsive], NgZone, PLATFORM_ID],
    useFactory: responsiveProviderFactory
};
var ResponsiveModule = /** @class */ (function () {
    function ResponsiveModule() {
    }
    ResponsiveModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [MediaDirective],
                    exports: [MediaDirective],
                    providers: [responsiveProvider]
                },] },
    ];
    /** @nocollapse */
    ResponsiveModule.ctorParameters = function () { return []; };
    return ResponsiveModule;
}());
export { ResponsiveModule };
//# sourceMappingURL=responsive.module.js.map